import {useBreakpointDown, useBreakpointUp} from '@travel-frontend/core';
import {
  Dialog,
  DialogBody,
  DialogHead,
  DialogTitle,
  LabelSmallBold,
  LabelXLargeSemibold,
  NewsletterBanner as NewsletterBannerUI,
  NewsletterLayerContent,
  NoWrap,
} from '@travel-frontend/ui-components';
import {Trans} from 'react-i18next';

type Props = {
  isDialogOpen: boolean;
  trackingSource: string;
  onOpenDialog: () => void;
  onCloseDialog: () => void;
};

export const NewsletterBannerRegular: React.FunctionComponent<Props> = ({
  isDialogOpen,
  trackingSource,
  onOpenDialog,
  onCloseDialog,
}) => {
  const mdUp = useBreakpointUp('md');
  const smDown = useBreakpointDown('sm');

  const Label = mdUp ? LabelXLargeSemibold : LabelSmallBold;

  let bannerTitle = 'banner.de.title';
  let dialogTitle = 'dialog.de.title';
  if (import.meta.env.VITE_LOCALE === 'de-CH') {
    bannerTitle = 'banner.ch.title';
    dialogTitle = 'dialog.ch.title';
  }

  return (
    <>
      <NewsletterBannerUI
        as="button"
        headline={null}
        text={
          <Trans
            ns="newsletterVoucher"
            i18nKey={bannerTitle}
            components={{
              b: <NoWrap as="b" />,
            }}
          />
        }
        onClick={onOpenDialog}
      />
      <Dialog open={isDialogOpen} onClose={onCloseDialog} fullScreen={smDown}>
        <DialogHead onClose={onCloseDialog}>
          <DialogTitle>
            <Label>
              <Trans ns="newsletterVoucher" i18nKey={dialogTitle} />
            </Label>
          </DialogTitle>
        </DialogHead>
        <DialogBody>
          <NewsletterLayerContent
            trackingSource={trackingSource}
            // @ts-expect-error ...
            margin="-1rem"
          />
        </DialogBody>
      </Dialog>
    </>
  );
};
